import { useState } from 'react';
import { motion } from 'framer-motion';
import { soundManager } from '../utils/sounds';

export function SoundToggle() {
  const [enabled, setEnabled] = useState(soundManager.isEnabled());

  const toggle = () => {
    const newState = soundManager.toggle();
    setEnabled(newState);

    // Play a test sound when enabling
    if (newState) {
      soundManager.playClick();
    }
  };

  return (
    <motion.button
      onClick={toggle}
      className="relative p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
      whileTap={{ scale: 0.95 }}
      aria-label={enabled ? 'Disabilita suoni' : 'Abilita suoni'}
      title={enabled ? 'Disabilita suoni' : 'Abilita suoni'}
    >
      {enabled ? (
        <motion.span
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          className="text-xl"
        >
          🔊
        </motion.span>
      ) : (
        <motion.span
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          className="text-xl"
        >
          🔇
        </motion.span>
      )}
    </motion.button>
  );
}
